import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { offeringTabs } from '../../data/homeContent';
import HomeIcon from './HomeIcon';

function HomeOfferings() {
  const [active, setActive] = useState(offeringTabs[0].id);
  const tab = offeringTabs.find((item) => item.id === active) || offeringTabs[0];

  return (
    <section className="home-section home-offerings">
      <div className="container">
        <div className="home-section-head">
          <p className="home-kicker">COMPREHENSIVE OFFERINGS</p>
          <h2>School ERP software that covers the whole campus</h2>
          <p className="home-lead">
            Mix of school ERP depth and connected products — academics, apps, learning, websites, and smart campus tools in one school management suite.
          </p>
        </div>

        <div className="home-offer-tabs" role="tablist">
          {offeringTabs.map((item) => (
            <button
              key={item.id}
              type="button"
              className={item.id === active ? 'is-active' : ''}
              onClick={() => setActive(item.id)}
            >
              <span className="home-offer-tab-icon">
                <HomeIcon name={item.tabIcon} size={16} />
              </span>
              {item.label}
            </button>
          ))}
        </div>

        <div className="home-offer-intro">
          <p>{tab.intro}</p>
        </div>

        <div className="home-card-grid">
          {tab.items.map((item, index) => (
            <Link key={item.title} to={item.to} className={`home-offer-card home-card-tone-${index + 1}`}>
              <div className="home-offer-card-head">
                <div className="home-card-icon" aria-hidden="true">
                  <HomeIcon name={item.icon} />
                </div>
                <span className="home-offer-num">0{index + 1}</span>
              </div>
              <div className="home-offer-card-body">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
                <div className="home-offer-read">Read more</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeOfferings;
